import React, { useState } from "react";
import axios from "axios";
import "../Pincodefinder/Style.css";
import "../Steelcity/css/style.css";
import "../Steelcity/css/shreeshystyle.css";
import "../Steelcity/css/bootstrap.min.css";
import "../Steelcity/css/responsive.css";
import Logo from "../Logo/A2zlogo.png";
import Swal from "sweetalert2";

const A2zLogisticsTracking = () => {
  const [searchValue, setSearchValue] = useState("");
  const [trackingData, setTrackingData] = useState<any[]>([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [showImage, setShowImage] = useState(false);
  const [error, setError] = useState("");

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const statusToStep: { [key: string]: number } = {
    Booked: 1,
    InTransit: 2,
    DELIVERED: 3,
    Delivered: 4,
  };

  const handleButtonClick = () => {
    setShowImage(!showImage);
  };

  const fetchData = async () => {
    try {
      if (!searchValue.trim()) {
        setError("Please enter a tracking number.");
        return;
      }

      const docket = searchValue.trim();
      const res = await axios.get(
        // 'https://a2zlogisticsolutions.in/A2ZLogisticsApi/TrackingData',
        "https://trackerex.com/TrackingControlerNodeJsApi/TrackingData",
        {
          params: {
            VendorName: "A2ZLOG", // 👈 ADD THIS
            awbNo: docket,
            refNo: docket,
          },
        },
      );
      const data = res.data;
      console.log(data, "API response ====================");

      if (data?.status === 1 && Array.isArray(data.data)) {
        const tryImageExtensions = async (
          awbNo: string,
        ): Promise<string | null> => {
          const extensions = ["jpg", "jpeg", "png"];
          for (const ext of extensions) {
            const url = `https://trackerex.com/Podimages${awbNo}.${ext}`;
            const exists = await checkImageExists(url);
            if (exists) return url;
          }
          return null;
        };

        const checkImageExists = (url: string): Promise<boolean> => {
          return new Promise((resolve) => {
            const img = new Image();
            img.src = url;
            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);
          });
        };

        const updatedData = await Promise.all(
          data.data.map(async (item: any) => {
            const imageUrl = await tryImageExtensions(item.awbNo);
            return {
              ...item,
              ImageLink: imageUrl,
              podHistory: item.podHistory || [], // ✅ keep API podHistory
            };
          }),
        );

        setTrackingData(updatedData);
        setError("");
        setSearchValue("");

        if (updatedData.length > 0) {
          const status = updatedData[0].Status;
          setCurrentStep(statusToStep[status] || 1);
        }
      } else {
        setTrackingData([]);
        Swal.fire({
          icon: "warning",
          title: "Docket Not Found",
          text: "The entered docket number was not found.",
        });
      }
    } catch (error: any) {
      console.error("Error:", error);
      setTrackingData([]);
      setError(
        error.response?.data?.message ||
          "Failed to fetch data. Please check your internet connection.",
      );
    }
  };

  return (
    <>
      <header className="navbarheader">
        {/* Top Marquee */}
        <div className="marquee-container">
          <div className="marquee-text">
            Welcome To A2Z Logistics Services &nbsp;&nbsp;&nbsp;
          </div>
        </div>

        {/* Desktop Navbar */}
        <div className="navbar-container d-none d-lg-flex">
          <div className="navbar-logo">
            <img
              src={Logo}
              alt="Company Logo"
              className="img-fluid"
              style={{ height: "100px", width: "auto", marginTop: "-40px" }}
            />
          </div>

          <nav className="navbar-links">
            <a href="https://a2zlogisticsolutions.in">Home</a>
            <a href="https://a2zlogisticsolutions.in/about-us.php">About</a>
            <a href="https://a2zlogisticsolutions.in/banned-items.php">
              Services
            </a>
            <a href="#">Document</a>
            <a href="https://a2zlogisticsolutions.in/contact-us.php">Contact</a>
          </nav>
        </div>

        {/* Mobile Navbar (Offcanvas) */}
        <nav className="navbar bg-light fixed-top d-lg-none">
          <div className="container-fluid">
            {/* Left-side hamburger button */}
            <button
              className="navbar-toggler me-2"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasNavbar"
              aria-controls="offcanvasNavbar"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            {/* Brand Logo (on the right) */}
            <a className="navbar-brand ms-auto" href="#">
              <img
                src={Logo}
                alt="Company Logo"
                style={{ height: "50px", width: "auto" }}
              />
            </a>

            {/* Offcanvas Menu (opens from left) */}
            <div
              className="offcanvas offcanvas-start"
              tabIndex={-1}
              id="offcanvasNavbar"
              aria-labelledby="offcanvasNavbarLabel"
            >
              <div className="offcanvas-header">
                <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
                  Menu
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>

              <div className="offcanvas-body">
                <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      href="https://a2zlogisticsolutions.in/index.php"
                    >
                      Home
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="https://a2zlogisticsolutions.in/about-us.php"
                    >
                      About
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="https://a2zlogisticsolutions.in/banned-items.php"
                    >
                      Services
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#">
                      Document
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="https://a2zlogisticsolutions.in/contact-us.php"
                    >
                      Contact
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </header>

      {/* Search Box */}
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <div className="shadow p-4">
              <input
                type="text"
                placeholder="Tracking Number(s)"
                className="form-control mb-2 text-center border border-info"
                value={searchValue}
                onChange={handleInputChange}
              />
              <button onClick={fetchData} className="DnlTrack w-100">
                TRACK HERE
              </button>
              {error && <div className="text-danger mt-2">{error}</div>}
              <p className="mt-2">To Track Multiple AwbNo</p>
            </div>
          </div>
        </div>
      </div>

      {/* Tracking Data */}
      <div className="container">
        <div className="row">
          <div className="col-lg-9">
            {trackingData.map((record, index) => (
              <div key={index} className="shadow p-4 mb-4">
                <h5 className="mb-3 text-center">Tracking Details</h5>
                <table className="table table-bordered table-sm mb-4">
                  <thead>
                    <tr>
                      <th>AwbNo</th>
                      <th>Ref_No</th>
                      <th>BookDate</th>
                      <th>Consignee_Name</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{record.awbNo}</td>
                      <td>{record.refNo || "-"}</td>
                      <td>{record.bookDate}</td>
                      <td>{record.consigneeName}</td>
                      <td>{record.Status}</td>
                    </tr>
                  </tbody>
                  <thead>
                    <tr>
                      <th>Qty</th>
                      {/* <th>Origin</th> */}
                      <th>Destination</th>
                      <th>Receiver Name</th>
                      <th>Delivery Date</th>
                      <th>Delivery Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{record.Qty}</td>
                      {/* <td>{record.Origin_Name}</td> */}
                      <td>{record.destinationName}</td>
                      <td>{record.recvName}</td>
                      <td>{record.delvDt}</td>
                      <td>{record.delvTime}</td>
                    </tr>

                    <tr>
                      <td colSpan={5} className="text-center">
                        {/* 🔹 Show button only if POD or Signature exists */}
                        {(record.podImg ||
                          record.ImageLink ||
                          record.signImg) && (
                          <button
                            onClick={handleButtonClick}
                            className="btn btn-success btn-sm"
                            style={{
                              fontSize: "12px",
                              padding: "2px 8px",
                              width: "auto",
                              minWidth: "unset",
                            }}
                          >
                            {showImage ? "Hide" : "POD_IMG"}
                          </button>
                        )}

                        {showImage && (
                          <div className="mt-3 text-center">
                            {/* POD Section */}
                            {(record.podImg || record.ImageLink) && (
                              <>
                                <h6>POD Image</h6>
                                <img
                                  src={record.podImg || record.ImageLink}
                                  alt="POD"
                                  className="img-fluid mb-3"
                                  style={{ maxWidth: "500px" }}
                                />
                                <br />
                                <a
                                  href={record.podImg || record.ImageLink}
                                  download={`POD_${record.awbNo || "image"}.jpg`}
                                  className="btn btn-primary btn-sm mt-2"
                                >
                                  ⬇ Download POD
                                </a>
                              </>
                            )}

                            {/* Signature Section */}
                            {record.signImg && (
                              <>
                                <h6 className="mt-4">Signature</h6>
                                <img
                                  src={record.signImg}
                                  alt="Signature"
                                  className="img-fluid"
                                  style={{ maxWidth: "200px" }}
                                />
                                <br />
                                <a
                                  href={record.signImg}
                                  download={`Signature_${record.awbNo || "image"}.png`}
                                  className="btn btn-secondary btn-sm mt-2"
                                >
                                  ⬇ Download Signature
                                </a>
                              </>
                            )}
                          </div>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>

                {/* Progress Steps */}
                <div
                  className="w-100 position-relative"
                  style={{ paddingBottom: "30px" }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "15px",
                      left: 0,
                      right: 0,
                      height: "4px",
                      backgroundColor: "#ccc",
                      zIndex: 0,
                    }}
                  >
                    <div
                      style={{
                        width: `${((currentStep - 1) / 2) * 100}%`,
                        height: "100%",
                        backgroundColor: "#007bff",
                        transition: "width 0.3s ease",
                      }}
                    ></div>
                  </div>

                  <div
                    className="steps-container d-flex justify-content-between align-items-center my-3"
                    style={{ position: "relative", zIndex: 1 }}
                  >
                    {["Booked", "InTransit", "DELIVERED"].map(
                      (stepLabel, idx) => {
                        const normalizedLabel = stepLabel.toLowerCase();
                        const stepNum = idx + 1;
                        const isActive = stepNum <= currentStep;

                        return (
                          <div
                            key={normalizedLabel}
                            className="text-center"
                            style={{ flex: 1 }}
                          >
                            <div
                              className={`step-circle ${
                                isActive ? "active" : ""
                              }`}
                              style={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "50%",
                                backgroundColor: isActive ? "#007bff" : "#ccc",
                                color: "white",
                                lineHeight: "30px",
                                margin: "0 auto",
                                fontWeight: "bold",
                              }}
                            >
                              {stepNum}
                            </div>
                            <div className="step-label mt-2">
                              {normalizedLabel.charAt(0).toUpperCase() +
                                normalizedLabel.slice(1)}
                            </div>
                          </div>
                        );
                      },
                    )}
                  </div>
                </div>
              </div>
            ))}

            {/* POD History */}
            {trackingData.map((record, index) => (
              <div key={index} className="shadow p-4 mb-4">
                <h5 className="mb-3 text-center">Status Tracking</h5>
                <table className="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th>AwbNo</th>
                      <th>Status_Date</th>
                      <th>Status_Time</th>
                      <th>Location_Update</th>
                      <th>Activity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {record.podHistory?.map((history: any, idx: number) => (
                      <tr key={idx}>
                        <td>{record.awbNo}</td>{" "}
                        {/* AWB comes from parent object */}
                        <td>{history.delvDt || "-"}</td>
                        <td>{history.delvTime || "-"}</td>
                        <td>{history.destinationName || "-"}</td>
                        <td>{history.remark || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        </div>
      </div>

      <footer className="footerDNL">
        {/* Top Section */}
        <div className="footer-top">
          <h2>Join Us Today And let Us Help You To Grow Your Business.</h2>
          <button className="footer-btn">Get Started →</button>
        </div>

        {/* Bottom Section */}
        <div className="footer-content">
          {/* Logo + About */}
          <div className="footer-col">
            <div>
              <img
                src={Logo}
                alt="Company Logo"
                className="img-fluid"
                style={{ height: "100px", width: "auto", marginTop: "-40px" }}
              />
            </div>
            <p>
              Reliable delivery services offering fast shipping, real-time
              tracking, and secure handling of your packages for local and
              international destinations
            </p>
            <div className="social-icons">
              <a href="#">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#">
                <i className="fab fa-facebook"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <a href="https://skmailing.in/index.html">Home</a>
              </li>
              <li>
                <a href="https://skmailing.in/about.html">About Us</a>
              </li>
              <li>
                <a href="https://skmailing.in/services.html">Service</a>
              </li>

              <li>
                <a href="https://trackerex.com/SkMailingTracking/">Tracking</a>
              </li>
              <li>
                <a href="https://skmailing.in/contact.html">Contact Us</a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-col">
            <h4>Services</h4>
            <ul>
              <li>Surface Cargo</li>
              <li>Air Cargo</li>
              <li>Bulk Express</li>
              <li>Door To Door Delivery</li>
              <li>Next Day Delivery</li>
            </ul>
          </div>

          {/* Address */}
          <div className="footer-col">
            <h4>Address</h4>
            <p>
              <strong>Head Office</strong>
              <br />
              B-3, Nageshwar Complex, Purna Bus Stop Near Bikaner Sweets, Purna
              Bhiwandi-421302
            </p>
            <p>
              <strong>Phone:</strong>(+91) 8805201700, 9766676629
            </p>
            <p>
              <strong>Mail:</strong>a2zlogisticsolutions@gmail.com
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p style={{ color: "white" }}>
            © 2025 A2Z LOGISTICS / All rights reserved
          </p>
          <div>
            <p>Powered by</p>
            <a href="https://www.neotechnet.com/"> Neotech IT Services</a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default A2zLogisticsTracking;
